function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: " M 299.711 808.297 L 296.32 806.602 C 295.642 806.263 222.068 768.289 180.365 745.912 C 136.628 721.839 138.323 679.458 138.662 674.372 L 138.662 450.938 L 143.409 449.243 C 217.661 420.762 296.32 421.44 299.711 421.101 C 302.762 421.101 381.761 420.762 456.013 449.243 L 460.76 450.938 L 460.76 674.372 C 461.099 679.119 462.794 721.839 419.057 745.912 C 377.353 768.628 303.779 806.263 303.101 806.602 L 299.711 808.297 Z ",
  fill: "url(#_lgradient_0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: " M 461.099 437.037 L 461.099 437.037 L 461.099 437.037 L 461.099 430.934 L 461.099 428.221 L 461.099 421.101 L 461.099 413.303 L 461.099 415.677 L 461.099 408.556 L 461.099 407.878 C 444.824 401.436 427.872 396.351 411.598 392.282 L 411.598 408.217 C 379.049 400.08 348.873 396.351 325.14 394.994 L 325.14 383.806 L 325.14 383.806 L 325.14 379.059 C 308.526 377.703 298.355 377.703 298.016 377.703 C 297.677 377.703 289.2 377.703 275.299 378.72 L 275.299 394.655 C 255.634 395.673 225.12 398.724 188.841 408.896 L 188.841 392.282 C 172.567 396.351 155.614 401.436 139.34 407.878 L 139.34 413.303 L 139.34 419.745 L 139.34 419.745 L 139.34 419.745 L 139.34 426.865 L 139.34 426.865 L 139.34 426.865 L 139.34 430.595 L 139.34 436.698 L 139.34 436.698 L 139.34 436.698 L 139.34 437.715 C 208.167 410.591 286.488 407.878 300.389 407.539 C 314.29 407.878 392.611 410.591 461.438 437.715 L 461.099 437.037 L 461.099 437.037 Z ",
  fill: "url(#_lgradient_1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: " M 139.001 406.861 L 139.001 407.2 L 139.001 407.2 L 139.001 406.861 Z ",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 334.972 692.681 L 334.972 692.681 C 332.599 692.003 331.582 689.968 332.26 687.934 C 335.65 677.763 344.466 648.943 343.109 639.789 C 342.77 637.416 341.753 635.381 340.058 633.347 C 338.702 631.652 339.041 629.278 340.736 627.922 C 342.431 626.566 344.805 626.905 346.161 628.6 C 348.873 631.991 350.229 635.381 350.907 638.772 C 352.942 651.656 341.075 686.578 339.719 690.647 C 339.041 692.003 337.006 693.02 334.972 692.681 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 344.805 667.591 C 342.431 667.252 341.075 665.218 341.075 662.844 L 341.753 638.772 C 341.414 637.077 340.397 635.042 339.041 633.347 C 337.345 631.313 337.685 628.261 339.719 626.566 C 341.753 624.871 344.805 625.21 346.5 627.244 C 349.212 630.635 350.568 634.025 351.247 637.755 C 351.247 638.094 351.247 638.433 351.247 638.772 L 350.568 663.183 C 350.568 665.896 348.195 667.93 345.483 667.93 C 345.483 667.93 345.144 667.93 344.805 667.591 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 321.749 715.736 C 321.41 715.736 321.41 715.736 321.071 715.736 C 319.376 715.058 318.359 713.024 319.037 710.99 L 342.77 650.639 C 343.448 648.943 345.483 647.926 347.517 648.604 C 349.212 649.282 350.229 651.317 349.551 653.351 L 325.818 713.702 C 325.479 715.058 323.444 716.075 321.749 715.736 Z ",
  fill: "rgb(60,37,21)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 263.432 692.681 L 263.432 692.681 C 265.806 692.003 266.823 689.968 266.145 687.934 C 262.754 677.763 253.939 648.943 255.295 639.789 C 255.634 637.416 256.651 635.381 258.347 633.347 C 259.703 631.652 259.364 629.278 257.669 627.922 C 255.973 626.566 253.6 626.905 252.244 628.6 C 249.531 631.991 248.175 635.381 247.497 638.772 C 245.463 651.656 257.33 686.578 258.686 690.647 C 259.364 692.003 261.398 693.02 263.432 692.681 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 253.6 667.591 C 255.973 667.252 257.33 665.218 257.33 662.844 L 256.651 638.772 C 256.99 637.077 258.008 635.042 259.364 633.347 C 261.059 631.313 260.72 628.261 258.686 626.566 C 256.651 624.871 253.6 625.21 251.905 627.244 C 249.192 630.635 247.836 634.025 247.158 637.755 C 247.158 638.094 247.158 638.433 247.158 638.772 L 247.836 663.183 C 247.836 665.896 250.209 667.93 252.922 667.93 C 252.922 667.93 253.261 667.93 253.6 667.591 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 276.655 715.736 C 276.994 715.736 276.994 715.736 277.334 715.736 C 279.029 715.058 280.046 713.024 279.368 710.99 L 255.634 650.639 C 254.956 648.943 252.922 647.926 250.888 648.604 C 249.192 649.282 248.175 651.317 248.853 653.351 L 272.587 713.702 C 272.926 715.058 274.96 716.075 276.655 715.736 Z ",
  fill: "rgb(60,37,21)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 291.913 559.095 C 288.522 558.417 285.81 557.4 283.436 555.704 C 282.758 555.365 282.419 554.687 282.08 554.009 L 258.686 489.929 C 258.008 488.233 259.025 485.86 260.72 485.521 C 262.754 484.843 264.789 485.86 265.467 487.555 L 288.183 550.958 C 290.896 552.653 294.964 552.992 300.05 552.653 C 302.084 552.314 303.779 554.009 304.119 556.043 C 304.458 558.078 302.762 559.773 300.728 559.773 C 297.677 559.434 294.625 559.434 291.913 559.095 Z ",
  fill: "rgb(60,37,21)"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: " M 300.389 712.007 L 298.016 712.007 C 298.016 712.007 245.802 657.42 245.802 631.313 L 245.802 627.583 C 245.802 601.476 269.874 557.739 293.947 557.739 L 303.779 557.739 C 328.53 557.739 351.925 601.137 351.925 627.583 L 351.925 631.313 C 352.942 657.42 300.389 712.007 300.389 712.007 Z ",
  fill: "url(#_lgradient_2)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: " M 347.517 605.206 L 251.227 605.206 L 268.179 569.606 L 328.191 569.606 L 347.517 605.206 Z ",
  fill: "rgb(60,37,21)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: " M 347.517 643.179 L 251.227 643.179 L 251.566 615.377 L 343.787 615.377 L 347.517 643.179 Z ",
  fill: "rgb(60,37,21)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: " M 321.749 680.475 L 278.012 680.475 L 261.059 652.334 L 336.667 652.334 L 321.749 680.475 Z ",
  fill: "rgb(60,37,21)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: " M 304.458 572.318 C 311.578 572.318 321.071 575.03 328.869 587.575 C 337.006 600.459 342.431 616.394 342.431 627.244 L 342.431 631.313 C 342.431 634.364 340.736 646.231 317.341 675.389 C 310.56 683.866 303.779 691.664 298.694 697.089 C 293.269 691.325 286.149 683.187 279.368 674.033 C 258.008 646.57 255.973 634.703 255.973 631.313 L 255.973 627.244 C 255.973 616.394 261.398 600.12 269.535 587.575 C 277.673 575.03 286.827 572.318 293.947 572.318 M 304.458 555.365 L 294.286 555.365 C 273.943 555.365 244.446 600.459 244.446 627.583 L 244.446 631.652 C 244.446 658.776 295.303 710.99 299.033 714.719 L 299.033 714.719 C 299.033 714.719 354.298 658.776 354.298 631.652 L 354.298 627.583 C 354.298 600.459 318.359 555.365 304.458 555.365 L 304.458 555.365 Z ",
  fill: "rgb(60,37,21)"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 286.488 557.4 L 286.488 557.4 L 239.699 581.133 C 239.021 581.472 238.343 582.15 238.343 583.168 L 231.901 619.107 C 231.562 621.141 233.596 623.175 235.291 622.497 C 260.042 611.987 279.368 589.609 286.149 560.112 C 286.488 559.095 286.488 558.078 286.488 557.4 C 286.827 557.061 286.488 557.061 286.488 557.4 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 174.601 582.489 C 170.194 589.27 166.803 596.73 164.43 605.206 C 163.752 607.579 165.786 609.613 168.159 608.596 C 181.043 602.154 256.99 568.927 278.012 558.756 C 280.724 557.4 279.368 555.026 276.655 555.365 L 176.296 581.472 C 175.279 581.472 174.94 581.811 174.601 582.489 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 192.232 563.842 C 191.215 563.503 190.198 563.842 189.519 564.52 C 186.468 567.232 183.756 570.284 181.382 573.335 L 204.099 568.588 L 192.232 563.842 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 227.154 587.236 L 170.872 615.716 C 168.837 616.734 168.837 620.124 170.872 620.802 C 174.94 622.836 179.348 624.532 184.095 625.549 C 197.318 629.278 210.541 628.939 223.085 625.888 C 224.103 625.549 224.781 624.871 225.12 623.515 L 230.884 589.949 C 231.223 588.253 229.188 586.219 227.154 587.236 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 213.253 565.537 C 214.27 565.876 215.287 565.876 216.304 565.876 L 279.368 551.297 C 273.604 548.245 271.57 546.211 265.128 544.177 C 242.072 538.074 219.017 542.821 200.369 555.365 C 198.335 556.722 198.674 559.773 200.708 560.451 C 201.047 560.79 209.523 564.181 213.253 565.537 Z ",
  fill: "rgb(60,37,21)"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_Q4xTn8ktPY3XtCDYANzjjziMBSp8CSVU"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 211.558 500.778 L 221.39 528.241 L 249.87 546.55 L 268.179 551.636 L 280.046 551.636 L 268.518 524.851 L 229.527 497.388 L 211.558 500.778 Z ",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_Q4xTn8ktPY3XtCDYANzjjziMBSp8CSVU)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 180.493 435.729 L 180.493 435.729 C 179.797 435.629 179.399 435.032 179.498 434.435 C 179.697 433.639 179.598 432.942 179.399 432.345 C 178.503 429.757 172.232 423.487 169.943 421.297 C 169.446 420.899 169.446 420.103 169.943 419.704 C 170.341 419.207 171.138 419.207 171.536 419.704 C 172.431 420.501 180.294 428.065 181.588 431.648 C 181.986 432.643 181.986 433.738 181.787 434.933 C 181.588 435.43 180.991 435.828 180.493 435.729 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 178.403 429.558 C 178.204 429.558 178.005 429.458 177.806 429.359 L 163.275 417.017 C 162.877 416.619 162.777 416.022 163.175 415.524 C 163.573 415.126 164.17 415.027 164.668 415.425 L 179.1 427.766 C 179.498 428.164 179.598 428.762 179.199 429.259 C 179 429.458 178.702 429.558 178.403 429.558 Z ",
  fill: "rgb(60,37,21)"
})))));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 306.831 559.095 C 310.221 558.417 312.934 557.4 315.307 555.704 C 315.985 555.365 316.324 554.687 316.663 554.009 L 340.058 489.929 C 340.736 488.233 339.719 485.86 338.024 485.521 C 335.989 484.843 333.955 485.86 333.277 487.555 L 310.56 550.619 C 307.848 552.314 303.779 552.653 298.694 552.314 C 296.659 551.975 294.964 553.67 294.625 555.704 C 294.286 557.739 295.981 559.434 298.016 559.434 C 300.728 559.434 303.779 559.434 306.831 559.095 Z ",
  fill: "rgb(60,37,21)"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 312.256 557.4 C 312.595 557.4 312.595 557.4 312.256 557.4 L 359.045 581.133 C 359.723 581.472 360.401 582.15 360.401 583.168 L 366.843 619.107 C 367.182 621.141 365.148 623.175 363.452 622.497 C 338.702 611.987 319.376 589.609 312.595 560.112 C 312.256 559.095 312.256 558.078 312.256 557.4 C 312.256 557.061 312.256 557.061 312.256 557.4 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 424.481 582.489 C 428.889 589.27 432.28 596.73 434.653 605.206 C 435.331 607.579 433.297 609.613 430.923 608.596 C 418.04 602.154 342.092 568.927 321.071 558.756 C 318.359 557.4 319.715 555.026 322.427 555.365 L 422.786 581.811 C 423.464 581.472 424.142 581.811 424.481 582.489 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 406.851 563.842 C 407.868 563.503 408.885 563.842 409.563 564.52 C 412.615 567.232 415.327 570.284 417.7 573.335 L 394.984 568.588 L 406.851 563.842 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 371.59 587.236 L 427.872 615.716 C 429.906 616.734 429.906 620.124 427.872 620.802 C 423.803 622.836 419.396 624.532 414.649 625.549 C 401.426 629.278 388.203 628.939 375.658 625.888 C 374.641 625.549 373.963 624.871 373.624 623.515 L 367.86 589.949 C 367.521 588.253 369.894 586.219 371.59 587.236 Z ",
  fill: "rgb(60,37,21)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 385.152 565.537 C 384.134 565.876 383.117 565.876 382.1 565.876 L 319.037 551.297 C 324.801 548.245 326.835 546.211 333.277 544.177 C 356.332 538.074 379.388 542.821 398.036 555.365 C 400.07 556.722 399.731 559.773 397.696 560.451 C 398.036 560.79 388.881 564.181 385.152 565.537 Z ",
  fill: "rgb(60,37,21)"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_QSyXqpsJv5OfC9xzJYgxsYlAw5q6ATnI"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 387.186 500.778 L 377.014 528.241 L 349.212 546.55 L 330.904 551.636 L 318.698 551.636 L 330.225 524.851 L 369.555 497.388 L 387.186 500.778 Z ",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_QSyXqpsJv5OfC9xzJYgxsYlAw5q6ATnI)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 191.143 435.729 L 191.143 435.729 C 191.84 435.629 192.238 435.032 192.138 434.435 C 191.939 433.639 192.039 432.942 192.238 432.345 C 193.134 429.757 199.404 423.487 201.693 421.297 C 202.191 420.899 202.191 420.103 201.693 419.704 C 201.295 419.207 200.499 419.207 200.101 419.704 C 199.205 420.501 191.342 428.065 190.048 431.648 C 189.65 432.643 189.65 433.738 189.849 434.933 C 190.048 435.43 190.546 435.828 191.143 435.729 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 193.233 429.558 C 193.432 429.558 193.631 429.458 193.83 429.359 L 208.262 417.017 C 208.66 416.619 208.76 416.022 208.362 415.524 C 207.964 415.126 207.366 415.027 206.869 415.425 L 192.437 427.866 C 192.039 428.264 191.939 428.861 192.337 429.359 C 192.536 429.458 192.835 429.558 193.233 429.558 Z ",
  fill: "rgb(60,37,21)"
})))));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 298.016 515.696 C 296.998 515.696 296.32 515.018 296.32 514.001 C 295.642 503.83 294.286 477.384 294.286 475.689 C 294.286 475.689 294.286 475.689 294.286 475.349 C 294.286 474.332 294.964 473.654 295.981 473.654 C 297.338 473.654 297.677 474.332 297.677 475.349 L 297.677 475.349 L 297.677 475.349 C 297.677 475.689 297.677 476.367 297.677 476.706 L 299.711 513.323 C 299.711 514.679 299.033 515.357 298.016 515.696 L 298.016 515.696 Z ",
  fill: "rgb(60,37,21)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 301.745 515.696 L 301.745 515.696 C 300.728 515.696 299.711 514.679 300.05 513.662 L 302.084 475.349 C 302.084 474.332 303.101 473.654 304.119 473.654 C 305.136 473.654 305.814 474.671 305.814 475.689 L 303.779 514.001 C 303.44 514.679 302.762 515.696 301.745 515.696 Z ",
  fill: "rgb(60,37,21)"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: " M 282.08 499.083 C 282.08 489.914 289.98 482.47 299.711 482.47 C 309.441 482.47 317.341 489.914 317.341 499.083 C 317.341 508.252 309.441 515.696 299.711 515.696 C 289.98 515.696 282.08 508.252 282.08 499.083 Z ",
  fill: "url(#_lgradient_3)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: " M 299.711 518.748 C 288.183 518.748 279.029 509.933 279.029 499.422 C 279.029 488.911 288.183 480.096 299.711 480.096 C 311.239 480.096 320.393 488.911 320.393 499.422 C 320.393 509.933 311.239 518.748 299.711 518.748 Z  M 299.711 485.86 C 291.574 485.86 285.132 491.963 285.132 499.422 C 285.132 506.881 291.574 512.984 299.711 512.984 C 307.848 512.984 314.29 506.881 314.29 499.422 C 314.29 491.963 307.848 485.86 299.711 485.86 Z ",
  fill: "rgb(60,37,21)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: " M 270.553 527.224 C 270.553 511.131 283.618 498.066 299.711 498.066 C 315.804 498.066 328.869 511.131 328.869 527.224 C 328.869 543.317 315.804 556.383 299.711 556.383 C 283.618 556.383 270.553 543.317 270.553 527.224 Z ",
  fill: "url(#_lgradient_4)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: " M 299.711 561.129 C 281.063 561.129 265.467 545.872 265.467 526.885 C 265.467 507.898 280.724 492.641 299.711 492.641 C 318.359 492.641 333.955 507.898 333.955 526.885 C 333.955 545.872 318.698 561.129 299.711 561.129 Z  M 299.711 503.491 C 286.488 503.491 275.977 514.34 275.977 527.224 C 275.977 540.108 286.827 550.958 299.711 550.958 C 312.595 550.958 323.444 540.108 323.444 527.224 C 323.444 514.34 312.934 503.491 299.711 503.491 Z ",
  fill: "rgb(60,37,21)"
});

var SvgLibcomIcon = function SvgLibcomIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "138.562 377.703 322.876 430.594",
    width: 322.876,
    height: 135.594,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_0",
    x1: "0.03107341127223575%",
    y1: "50.0207767341571%",
    x2: "100.04393273538864%",
    y2: "50.0207767341571%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(240,195,114)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(187,164,94)"
    }
  })), _ref2), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_1",
    x1: "0.02989473684210514%",
    y1: "49.84632768361588%",
    x2: "100.0434736842105%",
    y2: "49.84632768361588%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(240,195,114)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(187,164,94)"
    }
  })), _ref3, _ref4), _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_2",
    x1: "0.12969464540970588%",
    y1: "49.88967032967033%",
    x2: "100.71619772907773%",
    y2: "49.88967032967033%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(240,195,114)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(187,164,94)"
    }
  })), _ref8)), _ref9, _ref10, _ref11, _ref12), _ref13, _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _ref18, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_3",
    x1: "0.775000000000059%",
    y1: "50.13061224489799%",
    x2: "100.58750000000005%",
    y2: "50.13061224489799%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(240,195,114)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(187,164,94)"
    }
  })), _ref19, _ref20), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_4",
    x1: "0.8918604651162898%",
    y1: "49.878488372093074%",
    x2: "99.93139534883717%",
    y2: "49.878488372093074%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(240,195,114)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(187,164,94)"
    }
  })), _ref21, _ref22))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLibcomIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/libcom-icon.34d71f34.svg";
export { ForwardRef as ReactComponent };